import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiGet, apiPost, apiPut } from "../api";
import type { Schemas } from "../../api/types";
import type { User } from "../../auth/queries";
import { POLL_BASE_MS } from "./intervals";

export type UserCreate = Schemas["UserCreate"];
export type UserUpdate = Schemas["UserUpdate"];

/** Fetches all users (admin only). */
export function useUserList(enabled = true) {
  return useQuery<User[]>({
    queryKey: ["users"],
    queryFn: async () => {
      const res = await apiGet<{ items: User[] }>("/users");
      return res.items;
    },
    enabled,
    refetchInterval: POLL_BASE_MS,
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation<User, unknown, UserCreate>({
    meta: { suppressErrorToast: true },
    mutationFn: (input) => apiPost<User>("/users", input),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["users"] }),
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation<User, unknown, { id: string; input: UserUpdate }>({
    meta: { suppressErrorToast: true },
    mutationFn: ({ id, input }) => apiPut<User>(`/users/${id}`, input),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["users"] }),
  });
}
